<template>
  <div
    id="townsquare"
    class="square"
    :class="{
      public: grimoire.isPublic,
      spectator: session.isSpectator,
      vote: session.nomination,
    }"
  >

    <ul class="circle" :class="['size-' + players.length + '-' + (grimoire.isMaskGrimoire ? 2 : 1)]">

      <template v-for="(player, index) in players">
        <Player
          v-for="roleth in grimoire.isMaskGrimoire ? [1, 2] : [1]"
          :key="index + '-' + roleth"
          :player="player"
          :roleth="roleth"
          @trigger="handleTrigger(index, $event)"
          :class="{
            from: Math.max(swap, move, nominate) === index,
            swap: swap > -1,
            move: move > -1,
            nominate: nominate > -1,
          }"
        />
      </template>
    </ul>

    <div class="storyteller circle">
        <!-- Yan_ice: The story telller. -->
        <Player
          :key="100"
          :player="storyteller"
          :roleth="1"
          @trigger="handleTrigger(100, 0, $event)"
        ></Player>
        <!-- The story telller END. -->
    </div>

    <div
      class="bluffs"
      v-if="players.length"
      ref="bluffs"
      :class="{ closed: !isBluffsOpen }"
    >
      <h3>
        <span v-if="session.isSpectator">恶魔伪装</span>
        <span v-else>恶魔伪装</span>
        <font-awesome-icon icon="times-circle" @click.stop="toggleBluffs" />
        <font-awesome-icon icon="plus-circle" @click.stop="toggleBluffs" />
      </h3>
      <ul>
        <li
          v-for="index in bluffSize"
          :key="index"
          @click="openRoleModal(index * -1, 1)"
        >
          <Token :role="bluffs[index - 1]"></Token>
        </li>
      </ul>
    </div>

    <div class="fabled" :class="{ closed: !isFabledOpen }" v-if="fabled.length" >
      <h3>
        <span>传奇角色</span>
        <font-awesome-icon icon="times-circle" @click.stop="toggleFabled" />
        <font-awesome-icon icon="plus-circle" @click.stop="toggleFabled" />
      </h3>
      <ul>
        <li
          v-for="(role, index) in fabled"
          :key="index"
          @click="removeFabled(index)"
        >
          <div
            class="night-order first"
            v-if="nightOrder.get(role).first && grimoire.isNightOrder"
          >
            <em>{{ nightOrder.get(role).first }}.</em>
            <span v-if="role.firstNightReminder">{{
              role.firstNightReminder
            }}</span>
          </div>
          <div
            class="night-order other"
            v-if="nightOrder.get(role).other && grimoire.isNightOrder"
          >
            <em>{{ nightOrder.get(role).other }}.</em>
            <span v-if="role.otherNightReminder">{{
              role.otherNightReminder
            }}</span>
          </div>
          <Token :role="role"></Token>
        </li>
      </ul>
    </div>

    <ReminderModal :player-index="selectedPlayer" :player-roleth="selectedRoleth"></ReminderModal>
    <RoleModal :player-index="selectedPlayer" :player-roleth="selectedRoleth"></RoleModal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Player from "./Player";
import Token from "./Token";
import ReminderModal from "./modals/ReminderModal";
import RoleModal from "./modals/RoleModal";

export default {
  components: {
    Player,
    Token,
    RoleModal,
    ReminderModal,
  },
  computed: {
    ...mapGetters({ nightOrder: "players/nightOrder" }),
    ...mapState(["grimoire", "roles", "session", "loginbackend"]),
    ...mapState("players", ["players", "storyteller", "bluffs", "fabled"]),
  },
  data() {
    return {
      selectedPlayer: 0,
      selectedRoleth: 1,
      bluffSize: 3,
      swap: -1,
      move: -1,
      nominate: -1,
      isBluffsOpen: true,
      isFabledOpen: true,
    };
  },
  methods: {
    toggleBluffs() {
      this.isBluffsOpen = !this.isBluffsOpen;
    },
    toggleFabled() {
      this.isFabledOpen = !this.isFabledOpen;
    },
    removeFabled(index) {
      if (this.session.isSpectator) return;
      this.$store.commit("players/setFabled", { index });
    },

    /***  ======= 核心：更新真实可视高度 ======= ***/
    updateViewportUnits() {
      const vh = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;

      document.documentElement.style.setProperty("--svh", `${vh}px`);
    },
    /*** ===================================== ***/

    handleTrigger(playerIndex, [method, params]) {
      if (typeof this[method] === "function") {
        this[method](playerIndex, params);
      }
    },
    claimSeat(playerIndex) {
      if (!this.session.isSpectator) return;
      if (this.loginbackend.playerId === this.players[playerIndex].id) {
        this.$store.commit("session/claimSeat", -1);
      } else {
        this.$store.commit("session/claimSeat", playerIndex);
      }
    },
    openReminderModal(playerIndex, playerRoleth) {
      this.selectedPlayer = playerIndex;
      this.selectedRoleth = playerRoleth;
      this.$store.commit("toggleModal", "reminder");
    },
    openRoleModal(playerIndex, playerRoleth) {
      const player = this.players[playerIndex];
      if (this.session.isSpectator && player && player.role.team === "traveler")
        return;
      this.selectedPlayer = playerIndex;
      this.selectedRoleth = playerRoleth;
      this.$store.commit("toggleModal", "role");
    },
    async removePlayer(playerIndex) {
      if (this.session.isSpectator || this.session.lockedVote) return;
      if (
        await my_confirm(
          `你确定要移除 ${this.players[playerIndex].name} 吗？`,
        )
      ) {
        const { nomination } = this.session;
        if (nomination) {
          if (nomination.includes(playerIndex)) {
            this.$store.commit("session/nomination");
          } else if (
            nomination[0] > playerIndex ||
            nomination[1] > playerIndex
          ) {
            this.$store.commit("session/setNomination", [
              nomination[0] > playerIndex ? nomination[0] - 1 : nomination[0],
              nomination[1] > playerIndex ? nomination[1] - 1 : nomination[1],
            ]);
          }
        }
        this.$store.commit("players/kick", playerIndex);
        this.$store.commit("players/remove", playerIndex);
      }
    },
    swapPlayer(from, to) {
      if (this.session.isSpectator || this.session.lockedVote) return;
      if (to === undefined) {
        this.cancel();
        this.swap = from;
      } else {
        if (this.session.nomination) {
          const swapTo = this.players.indexOf(to);
          const updatedNomination = this.session.nomination.map((nom) => {
            if (nom === this.swap) return swapTo;
            if (nom === swapTo) return this.swap;
            return nom;
          });
          if (
            this.session.nomination[0] !== updatedNomination[0] ||
            this.session.nomination[1] !== updatedNomination[1]
          ) {
            this.$store.commit("session/setNomination", updatedNomination);
          }
        }
        this.$store.commit("players/swap", [
          this.swap,
          this.players.indexOf(to),
        ]);
        this.cancel();
      }
    },
    movePlayer(from, to) {
      if (this.session.isSpectator || this.session.lockedVote) return;
      if (to === undefined) {
        this.cancel();
        this.move = from;
      } else {
        if (this.session.nomination) {
          const moveTo = this.players.indexOf(to);
          const updatedNomination = this.session.nomination.map((nom) => {
            if (nom === this.move) return moveTo;
            if (nom > this.move && nom <= moveTo) return nom - 1;
            if (nom < this.move && nom >= moveTo) return nom + 1;
            return nom;
          });
          if (
            this.session.nomination[0] !== updatedNomination[0] ||
            this.session.nomination[1] !== updatedNomination[1]
          ) {
            this.$store.commit("session/setNomination", updatedNomination);
          }
        }
        this.$store.commit("players/move", [
          this.move,
          this.players.indexOf(to),
        ]);
        this.cancel();
      }
    },
    nominatePlayer(from, to) {
      if (this.session.isSpectator || this.session.lockedVote) return;
      if (to === undefined) {
        this.cancel();
        if (from !== this.nominate) {
          this.nominate = from;
        }
      } else {
        const nomination = [this.nominate, this.players.indexOf(to)];
        this.$store.commit("session/nomination", { nomination });
        this.cancel();
      }
    },
    cancel() {
      this.move = -1;
      this.swap = -1;
      this.nominate = -1;
    },
  },

  /*** ===== 生命周期：自动绑定 VisualViewport 更新 ===== ***/
  mounted() {
    const update = () => this.updateViewportUnits();
    update();

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", update);
      window.visualViewport.addEventListener("scroll", update);
    }
    window.addEventListener("resize", update);
  },
  beforeDestroy() {
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.updateViewportUnits);
      window.visualViewport.removeEventListener("scroll", this.updateViewportUnits);
    }
    window.removeEventListener("resize", this.updateViewportUnits);
  },
  /*** ===================================================== **/

};
</script>


<style lang="scss">
@use "sass:math";
@import "../vars.scss";

.circle {
  padding: 0;
  width: 95vmin;
  height: 95vmin;
  list-style: none;
  margin: 0;

  > li {
    position: absolute;
    left: 50%;
    height: 50%;
    transform-origin: 0 100%;
    pointer-events: none;

    &:hover {
      z-index: 25 !important;
    }

    > .player {
      margin-left: -50%;
      width: 100%;
      pointer-events: all;
    }
    > .reminder {
      margin-left: -25%;
      width: 50%;
      pointer-events: all;
    }
  }
}

@mixin on-circle($item-count, $group-count) {
  $group-angle: math.div(360deg, $item-count); // 每组在圆上的角度跨度
  $inner-angle-step: math.min(math.div($group-angle, $group-count+0.35),30); // 组内控件的角度间隔

  $index: 1;
  @for $group from 0 through ($item-count - 1) {
    $base-rot: $group * $group-angle;
    @for $member from 0 through ($group-count - 1) {
      $total-rot: $base-rot + $member*$inner-angle-step;

      &:nth-child(#{$index}) {
        transform: rotate($total-rot);

        // 保证内容正向
        > * {
          transform: rotate(-$total-rot);
        }

        // animation cascade
        .life,
        .token,
        .shroud,
        .night-order,
        .seat {
          animation-delay: ($index - 1) * 50ms;
          transition-delay: ($index - 1) * 50ms;
        }

        // tooltip 和 menu 样式可以沿用原有逻辑，或者按 total-rot 是否小于 180deg 判断左右
        @if $total-rot % 360 < 180deg {
          z-index: ($item-count * $group-count) - $index + 1;
          .player > .menu {
            left: auto;
            right: 110%;
            margin-right: 15px;
            &:before {
              border-left-color: black;
              border-right-color: transparent;
              right: auto;
              left: 100%;
            }
          }
          .ability {
            right: 120%;
            left: auto;
            &:before {
              border-right-color: transparent;
              border-left-color: black;
              right: auto;
              left: 100%;
            }
          }
          .pronouns {
            left: 110%;
            right: auto;
            &:before {
              border-left-color: transparent;
              border-right-color: black;
              left: auto;
              right: 100%;
            }
          }
          .fold-enter-active,
          .fold-leave-active {
            transform-origin: right center;
          }
          .fold-enter,
          .fold-leave-to {
            transform: perspective(200px) rotateY(-90deg);
          }
        } @else {
          z-index: $index;
        }
      }

      $index: $index + 1;
    }
  }
}


@for $i from 1 through 20 {
  @for $g from 1 through 2 {
    .circle.size-#{$i}-#{$g} > li {
      @include on-circle($i, $g);
    }
  }
}


#townsquare {
  width: 100%;
  height: var(--svh);
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}


/***** Demon bluffs / Fabled *******/
#townsquare > .storyteller {
  position: absolute;
  top: 10px;
  left: 25px;
  width: 14vh;
  height: 14vh;

    > .player {
      margin-left: -50%;
      width: 100%;
      pointer-events: all;
    }
}

#townsquare > .bluffs,
#townsquare > .fabled {
  position: absolute;
  &.bluffs {
    left: 10px;
    bottom: 10px;
  }
  &.fabled {
    right: 10px;
    bottom: 10px;
    .ability {
          right: 120%;
          left: auto;
          &:before {
            border-right-color: transparent;
            border-left-color: black;
            right: auto;
            left: 100%;
          }
    }
  }

  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 3px solid black;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5));
  transform-origin: bottom left;
  transform: scale(1);
  opacity: 1;
  transition: all 200ms ease-in-out;
  z-index: 50;

  > svg {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    &:hover {
      color: red;
    }
  }
  h3 {
    margin: 5px 1vh 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    span {
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    svg {
      cursor: pointer;
      flex-grow: 0;
      &.fa-times-circle {
        margin-left: 1vh;
      }
      &.fa-plus-circle {
        margin-left: 1vh;
        display: none;
      }
      &:hover path {
        fill: url(#demon);
        stroke-width: 30px;
        stroke: white;
      }
    }
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    li {
      width: 14vh;
      height: 14vh;
      margin: 0 0.5%;
      display: inline-block;
      transition: all 250ms;
    }
  }
  &.closed {
    svg.fa-times-circle {
      display: none;
    }
    svg.fa-plus-circle {
      display: block;
    }
    ul li {
      width: 0;
      height: 0;
      .night-order {
        opacity: 0;
      }
      .token {
        border-width: 0;
      }
    }
  }
}

#townsquare.public > .bluffs {
  opacity: 0;
  transform: scale(0.1);
}

.fabled ul li .token:before {
  content: " ";
  opacity: 0;
  transition: opacity 250ms;
  background-image: url("../assets/icons/x.png");
  z-index: 2;
}

/**** Night reminders ****/
.night-order {
  position: absolute;
  width: 100%;
  cursor: pointer;
  opacity: 1;
  transition: opacity 200ms;
  display: flex;
  top: 0;
  align-items: center;
  pointer-events: none;

  &:after {
    content: " ";
    display: block;
    padding-top: 100%;
  }

  #townsquare.public & {
    opacity: 0;
    pointer-events: none;
  }

  &:hover ~ .token .ability {
    opacity: 0;
  }

  span {
    display: flex;
    position: absolute;
    padding: 5px 10px 5px 30px;
    width: 350px;
    z-index: 25;
    font-size: 70%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    border: 3px solid black;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5));
    text-align: left;
    align-items: center;
    opacity: 0;
    transition: opacity 200ms ease-in-out;

    &:before {
      transform: rotate(-90deg);
      transform-origin: center top;
      left: -98px;
      top: 50%;
      font-size: 100%;
      position: absolute;
      font-weight: bold;
      text-align: center;
      width: 200px;
    }

    &:after {
      content: " ";
      border: 10px solid transparent;
      width: 0;
      height: 0;
      position: absolute;
    }
  }

  &.first span {
    right: 120%;
    background: linear-gradient(
      to right,
      $townsfolk 0%,
      rgba(0, 0, 0, 0.5) 20%
    );
    &:before {
      content: "First Night";
    }
    &:after {
      border-left-color: $townsfolk;
      margin-left: 3px;
      left: 100%;
    }
  }

  &.other span {
    left: 120%;
    background: linear-gradient(to right, $demon 0%, rgba(0, 0, 0, 0.5) 20%);
    &:before {
      content: "Other Nights";
    }
    &:after {
      right: 100%;
      margin-right: 3px;
      border-right-color: $demon;
    }
  }

  em {
    font-style: normal;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid black;
    filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.5));
    font-weight: bold;
    opacity: 1;
    pointer-events: all;
    transition: opacity 200ms;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;
  }

  &.first em {
    left: -10%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, $townsfolk 100%);
  }

  &.other em {
    right: -10%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, $demon 100%);
  }

  em:hover + span {
    opacity: 1;
  }

  // adjustment for fabled
  .fabled &.first {
    span {
      right: auto;
      left: 40px;
      &:after {
        left: auto;
        right: 100%;
        margin-left: 0;
        margin-right: 3px;
        border-left-color: transparent;
        border-right-color: $townsfolk;
      }
    }
  }
}

#townsquare:not(.spectator) .fabled ul li:hover .token:before {
  opacity: 1;
}
</style>
